// Resource types. These are returned as resource_type in the API response.
export const AlertResourceTypes = {
  SHIFT: 'Shift',
  JOB: 'Job',
  LISTING: 'Listing',
  WORKER: 'Worker',
  AGENCY: "AgencyShift"
} as const
